import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import {
    Card,
    CardActions,
    CardContent,
    CardHeader,
    TextField,
    Button,
    Grid,
    Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {Loader, IconPickerDropdown} from "../../../../../Components";
import { setRightDrawer } from "../../../../Common/App";
import {useDispatch, } from "react-redux";
import { addDepartment,  } from "../../Redux/Action";
import { useNavigate } from "react-router-dom";

export const AddItem = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState('');
    const [, setStatus] = useState('info');
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState({
        department_name: '',
        manager_id: '',
        icon: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        setIsLoading(true);
        await addDepartment({ dispatch, data }).then((res) => {
            if(res['success']){
                setData({});
                dispatch(setRightDrawer({ component: null, open: false }));
                if (res.data?.id) {
                    navigate('/departments/' + res.data?.id);
                }
            }
            setIsLoading(false);
            setErrors(res.errors);
            setMessage(res.message);
            setStatus(res.status);
        });
    };

    return (
        <Card>
            <CardHeader
                title={"Add Department"}
                action={
                    <IconButton
                        aria-label="close"
                        onClick={() => dispatch(setRightDrawer({ component: null, open: false }))}
                    >
                        <CloseIcon />
                    </IconButton>
                }
                avatar={<Loader isLoading={isLoading} type={"linear"}/>}
            />
            <CardContent>
                {message && <Alert sx={{mb:2}} severity="error">{message}</Alert> }
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Department Name"
                            name="department_name"
                            variant="outlined"
                            size="large"
                            onChange={handleChange}
                            error={!!errors?.department_name}
                            helperText={errors?.department_name}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <IconPickerDropdown
                            label="Department Icon"
                            value={data.icon}
                            onChange={(icon) => setData({...data, icon})}
                            error={!!errors?.icon}
                            helperText={errors?.icon || 'Select an icon to represent this department'}
                        />
                    </Grid>
                </Grid>
            </CardContent>
            <CardActions>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                >
                    Add Department
                </Button>
                <Button
                    variant="contained"
                    color={"inherit"}
                    onClick={() => dispatch(setRightDrawer({ component: null, open: false }))}
                >
                    Close
                </Button>
            </CardActions>
        </Card>
    );
};
